import React from 'react';
import CustomDeletePage from 'components/custom-pages/CustomDelete';

const Delete = ({ data, handleClick }) => {
  return (
    <CustomDeletePage
      pageTitle={'Delete Vehicle Make'}
      url={'vehicle-make-master'}
      queryKey="vehicle-make-master"
      title={'Vehicle Make'}
      id={data?._id}
      handleClick={handleClick}
    />
  );
};

export default Delete;
